import { render } from "./Marquee.vue?vue&type=template&id=b51d5702&ts=true"
import script from "./Marquee.vue?vue&type=script&lang=ts"
export * from "./Marquee.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__